// extracted by mini-css-extract-plugin
export default {"Row":"CategoryLeaderRow_Row__wgGZk"};